var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkein = function SvgLinkein(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#434343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1 7.2h-15a1.3 1.3 0 0 0-1.3 1.3v15a1.3 1.3 0 0 0 1.3 1.3h15a1.299 1.299 0 0 0 1.3-1.3v-15a1.299 1.299 0 0 0-1.3-1.3ZM13.047 22.193H10.4v-8.405h2.646v8.405Zm-1.325-9.57a1.52 1.52 0 1 1 1.528-1.518 1.498 1.498 0 0 1-1.528 1.518ZM22.799 22.2h-2.645v-4.592c0-1.354-.575-1.772-1.319-1.772-.784 0-1.554.592-1.554 1.807V22.2h-2.646v-8.406h2.544v1.165h.035c.255-.517 1.15-1.401 2.515-1.401 1.476 0 3.071.876 3.071 3.443v5.2Z",
    fill: "#fff"
  })));
};
export default SvgLinkein;